export default {
    importEmployeeData: 'นำเข้าข้อมูลพนักงาน',
    downloadErrorFile: 'คุณสามารถดาวโหลดไฟล์ที่มีข้อมูลผิดพลาด เพื่อเเก้ไขให้ถูกต้อง เเละกรุณาอัพโหลดใหม่อีกครั้ง'
}
